<div class="table-container mat-elevation-z8">
  <!-- Header inside table container -->
  <div class="header-container">
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event)" [(ngModel)]="filterValue" placeholder="Filtra">
    </mat-form-field>
    <button mat-icon-button (click)="clearFilter()" aria-label="Clear filter" *ngIf="filterValue.length > 0">
      <mat-icon>clear</mat-icon>
    </button>
    <button title="{{'labels.save' | translate}}" (click)="closeDialog()" mat-icon-button color="primary" aria-label="icon-button save">
      <mat-icon>save</mat-icon>
    </button>
  </div>

  <table mat-table [dataSource]="this.dataSource" matSort class="custom-table">
    <!-- Dynamic Columns -->
    <ng-container *ngFor="let column of getColumnKeys(this.dataSource?.data)" [matColumnDef]="column">
      <!-- Header Cell -->
      <ng-container *matHeaderCellDef>
        <th mat-header-cell mat-sort-header class="custom-header-cell">
          <ng-container [ngSwitch]="column">
            <span *ngSwitchCase="'prezzoCalice'">Prezzo al calice</span>
            <span *ngSwitchCase="'prezzoBottiglia'">Prezzo alla bottiglia</span>
            <span *ngSwitchDefault>{{ column.replace('_', ' ') }}</span>
          </ng-container>
        </th>
      </ng-container>

      <!-- Data Cell -->
      <td mat-cell *matCellDef="let element" class="custom-data-cell">
        <ng-container [ngSwitch]="column">
          <ng-container *ngSwitchCase="'prezzoCalice'">
            <mat-form-field appearance="fill" floatLabel="always" class="custom-form-field">
              <mat-label>Prezzo al calice</mat-label>
              <input matInput type="text" placeholder="0.00" [(ngModel)]="element[column]" [ngModelOptions]="{standalone: true}">
              <span matPrefix>€&nbsp;</span>
            </mat-form-field>
          </ng-container>
          <ng-container *ngSwitchCase="'prezzoBottiglia'">
            <mat-form-field appearance="fill" floatLabel="always" class="custom-form-field">
              <mat-label>Prezzo alla bottiglia</mat-label>
              <input matInput type="text" placeholder="0.00" [(ngModel)]="element[column]" [ngModelOptions]="{standalone: true}">
              <span matPrefix>€&nbsp;</span>
            </mat-form-field>
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{ element[column] }}
          </ng-container>
        </ng-container>
      </td>
    </ng-container>

    <!-- Header Row -->
    <tr mat-header-row *matHeaderRowDef="getColumnKeys(this.dataSource?.data); sticky: true" class="header"></tr>

    <!-- Data Rows with Conditional Class -->
    <tr mat-row *matRowDef="let row; columns: getColumnKeys(this.dataSource?.data)"
        [ngClass]="{'highlight-row': row.prezzoCalice || row.prezzoBottiglia}"
        class="custom-data-row">
    </tr>
  </table>

  <mat-paginator class="paginator" [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="10"
                 [length]="this.dataSource?.data?.length"></mat-paginator>
</div>

<mat-button-toggle-group [(ngModel)]="selectedCategory" (change)="this.applyFilterCategory()">
  <mat-button-toggle *ngFor="let category of this.macroCategorie" value="{{category.title}}" style="height: 50px; display: flex;">
    <b>{{ category.title }}</b>
  </mat-button-toggle>
</mat-button-toggle-group>
